import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";

class Label extends Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	static propTypes = {
		/** HTML ID for associated input */
		htmlFor: PropTypes.string.isRequired,
		/** Label Text */
		label: PropTypes.string.isRequired,
		/** Display an asterisk after label if true */
		required: PropTypes.bool
	};

	static defaultProps = {

	};

	render() {
		const {htmlFor, label, required} = this.props;
		return (
			<label style={{color: required ? 'red' : ''}} htmlFor={htmlFor}>
				{label}
				{
					required &&
					<span > * </span>
				}
			</label>
		);
	}
}

export default Label;
